// material-ui
import LinearProgress from '@mui/material/LinearProgress';
import { useTheme, styled } from '@mui/material/styles';

// styles
const LoaderWrapper = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 1301,
  width: '100%'
});

// ==============================|| LOADER ||============================== //
const Loader = () => {
  const theme = useTheme();

  return (
    <LoaderWrapper>
      <LinearProgress sx={{
        '& .MuiLinearProgress-bar': {
          backgroundColor: theme.palette.secondary.dark
        },
        backgroundColor: theme.palette.secondary.light
      }} 
    />
    </LoaderWrapper>
  );
};

export default Loader;
